const availableFulfillmentTypes = {
  Shipping: 'ShippingFulfillmentMethod',
  Delivery: 'DeliveryFulfillmentMethod',
  UberDirect: 'UberDirectFulfillmentMethod',
  Pickup: 'PickupFulfillmentMethod'
}

const labels = {
  ShippingFulfillmentMethod: 'Shipping',
  DeliveryFulfillmentMethod: 'Delivery',
  UberDirectFulfillmentMethod: 'Uber Direct',
  PickupFulfillmentMethod: 'Pickup'
}

const badgeThemes = {
  PickupFulfillmentMethod: 'bg-pink-100 text-pink-700',
  DeliveryFulfillmentMethod: 'bg-indigo-100 text-indigo-700',
  ShippingFulfillmentMethod: 'bg-orange-100 text-orange-700',
  UberDirectFulfillmentMethod: 'bg-emerald-100 text-emerald-700'
}

const deliveryLikeTypes = ['DeliveryFulfillmentMethod', 'ShippingFulfillmentMethod', 'UberDirectFulfillmentMethod']

const fulfillmentTypeOptions = Object.values(availableFulfillmentTypes).map(value => ({ value, name: labels[value] }))

const fulfillmentTypeLabel = type => labels[type] || (type ? type.replace('-', ' ') : '')

const fulfillmentTypeBadgeTheme = type => badgeThemes[type] || 'bg-gray-100 text-gray-700'

const isDeliveryLikeType = type => deliveryLikeTypes.includes(type)

export {
  availableFulfillmentTypes,
  fulfillmentTypeBadgeTheme,
  fulfillmentTypeLabel,
  fulfillmentTypeOptions,
  isDeliveryLikeType
}
